export const DataPanel = ({ items = [] }) => {
  return (
    <dl
      className="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2"
      data-testid="tracking-data-panel"
    >
      {items.map((it, i) => (
        <div
          key={it.label + i}
          className="border-b border-slate-100 pb-3 last:border-0 sm:last:border-b"
        >
          <dt className="text-xs font-medium uppercase tracking-wider text-slate-500">
            {it.label}
          </dt>
          <dd className="mt-1 text-sm font-semibold text-slate-900 break-words">
            {it.value || "—"}
          </dd>
        </div>
      ))}
    </dl>
  );
};
